import service from '@/api/billables';
import {handleError, loading} from "../generators/helpers";

export const state = {
    service: service(),
    all: [],
    categorized: [],
}

export const mutations = {
    'SET_CATEGORIZED': function (state, items = []) {
        state.categorized = items || [];
    },
}

export const getters = {
    products: function (state) {
        return JSON.parse(JSON.stringify(state.all.filter(item => item.type === 'Appon\\Projects\\Models\\Product')));
    },
    services: function (state) {
        return JSON.parse(JSON.stringify(state.all.filter(item => item.type === 'Appon\\Projects\\Models\\Service')));
    },
    categorized: function (state) {
        return JSON.parse(JSON.stringify(state.categorized));
    },
};

export const actions = {
    categorized: function ({commit, state}, filters) {
        loading(commit)

        return state.service.categorized(filters).then(response => {
            commit('SET_CATEGORIZED', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },
}
